export const de = {
  "app.suiteName": "Roughly",
  "app.suiteKicker": "Roughly – eine Schätzspiel-Sammlung",
  "app.suiteTagline": "Dein Bauchgefühl auf dem Prüfstand.",

  "nav.langSwitch.de": "DE",
  "nav.langSwitch.en": "EN",
  "nav.langSwitch.label": "Sprache wählen",

  "hub.loadError": "Die Spiele konnten nicht geladen werden. Bitte später erneut versuchen.",
  "hub.loading": "Lädt …",

  "footer.imprint": "Impressum",
  "footer.privacy": "Datenschutz",
  "footer.credits": "Quellen & Credits",

  "page.notFound.title": "Seite nicht gefunden",
  "page.notFound.body": "Diese Seite gibt es nicht (mehr).",
  "page.notFound.backHome": "Zur Startseite",

  "page.loadError": "Diese Seite konnte nicht geladen werden.",

  "common.backHome": "Zur Startseite",
  "common.loading": "Lädt …",
  "common.noTimeLimit": "Kein Zeitlimit",

  "endscreen.round": "Runde",
  "endscreen.copyResult": "Ergebnis kopieren",
  "endscreen.copied": "Kopiert!",
  "endscreen.replay": "Nochmal spielen",

  "timeslip.tagline": "5 Ereignisse. Eine Reihenfolge. Wie gut ist dein Gespür für Geschichte?",
  "timeslip.start.categoriesLabel": "Kategorien",
  "timeslip.start.allCategories": "Alle",
  "timeslip.start.difficultyLabel": "Schwierigkeit",
  "timeslip.start.difficulty.easy": "Leicht",
  "timeslip.start.difficulty.normal": "Normal",
  "timeslip.start.difficulty.hard": "Schwer",
  "timeslip.start.startButton": "Spiel starten",
  "timeslip.start.notEnoughCards": "Für diese Auswahl gibt es noch zu wenige Karten. Wähle mehr Kategorien oder eine andere Schwierigkeit.",
  "timeslip.start.loadError": "Die Kategorien konnten nicht geladen werden.",
  "timeslip.start.categoriesHint": "5 Runden · ca. 4 Min.",
  "timeslip.start.difficultyInfo.easy": "Nur sehr bekannte Ereignisse, mindestens 25 Jahre auseinander.",
  "timeslip.start.difficultyInfo.normal": "Bekannte Ereignisse, mindestens 8 Jahre auseinander.",
  "timeslip.start.difficultyInfo.hard": "Auch weniger bekannte Ereignisse, teils nur 2 Jahre auseinander.",

  "timeslip.play.topLabel": "Früher",
  "timeslip.play.bottomLabel": "Später",
  "timeslip.play.dragHandle": "Ziehen",
  "timeslip.play.check": "Prüfen",
  "timeslip.play.next": "Weiter",
  "timeslip.play.showCorrectOrder": "Richtige Reihenfolge zeigen",
  "timeslip.play.showMyOrder": "Meine Reihenfolge zeigen",
  "timeslip.play.more": "Mehr",
  "timeslip.play.source": "Quelle",
  "timeslip.play.gameLoadError": "Das Spiel konnte nicht gestartet werden.",
  "timeslip.play.summaryLine": "{correct} von {total} richtig · {points} Punkte",
  "timeslip.play.roundOf": "Runde {current} von {total}",
  "timeslip.play.timeUp": "Zeit abgelaufen!",
  "timeslip.play.totalScore": "Gesamt: {total} Punkte",
  "timeslip.play.cancelGame": "Spiel abbrechen",

  "crowflight.tagline": "Wie weit ist es wirklich? Sortieren, vergleichen, schätzen.",
  "crowflight.start.regionLabel": "Region",
  "crowflight.start.world": "Welt",
  "crowflight.start.loadError": "Die Regionen konnten nicht geladen werden.",
  "crowflight.start.difficultyInfo.easy": "Nur sehr bekannte Orte, Entfernungen und Breitengrade deutlich unterschiedlich.",
  "crowflight.start.difficultyInfo.normal": "Bekannte Orte, Entfernungen und Breitengrade moderat unterschiedlich.",
  "crowflight.start.difficultyInfo.hard": "Auch weniger bekannte Orte, Entfernungen und Breitengrade oft sehr knapp beieinander.",
  "crowflight.continent.africa": "Afrika",
  "crowflight.continent.asia": "Asien",
  "crowflight.continent.europe": "Europa",
  "crowflight.continent.north_america": "Nordamerika",
  "crowflight.continent.south_america": "Südamerika",
  "crowflight.continent.oceania": "Ozeanien",

  "crowflight.play.hint.get": "Hinweis anzeigen (−20 Punkte)",
  "crowflight.play.hint.view": "Hinweis erneut ansehen",
  "crowflight.play.hint.close": "Schließen",
  "crowflight.play.r1.title": "Entfernung sortieren",
  "crowflight.play.r1.near": "Näher",
  "crowflight.play.r1.far": "Weiter",
  "crowflight.play.r2.title": "Norden nach Süden",
  "crowflight.play.r2.instruction": "Ordne diese Orte von Norden nach Süden.",
  "crowflight.play.r2.north": "Norden",
  "crowflight.play.r2.south": "Süden",
  "crowflight.play.r3.title": "Näher oder weiter?",
  "crowflight.play.r3.prompt": "Welcher Ort ist näher dran …",
  "crowflight.play.r3.feedback": "{a} liegt {distA} km entfernt, {b} {distB} km.",
  "crowflight.play.r3.duelOf": "Duell {current} von {total}",
  "crowflight.play.r4.title": "Entfernung schätzen",
  "crowflight.play.r4.fromTo": "{from} nach {to}",
  "crowflight.play.r4.lockIn": "Festlegen",
  "crowflight.play.r4.summary": "Du: {guess} km · Richtig: {truth} km · {direction} → {points} Punkte",
  "crowflight.play.r4.exact": "genau richtig",
  "crowflight.play.r4.tooFar": "zu weit geschätzt",
  "crowflight.play.r4.tooClose": "zu nah geschätzt",
  "crowflight.play.gameLoadError": "Das Spiel konnte nicht gestartet werden.",

  "huesswork.tagline": "7 Farbboxen, eine fehlt. Triffst du die Mitte des Verlaufs?",
  "huesswork.start.difficultyInfo.easy": "Die 7 Farbboxen liegen eng beieinander, viel Farbkontext sichtbar.",
  "huesswork.start.difficultyInfo.normal": "Die 7 Farbboxen liegen mittel weit auseinander.",
  "huesswork.start.difficultyInfo.hard": "Die 7 Farbboxen liegen weit auseinander, wenig Farbkontext sichtbar.",
  "huesswork.play.hueAriaLabel": "Farbton",
  "huesswork.play.areaAriaLabel": "Sättigung und Helligkeit",
  "huesswork.play.lockIn": "Festlegen",
  "huesswork.reveal.right": "Richtig",
  "huesswork.reveal.yourColor": "Dein Ton",
  "huesswork.reveal.viewRightColor": "Richtige Farbe zeigen",
  "huesswork.reveal.viewMyColor": "Meine Farbe zeigen",
  "huesswork.play.gameLoadError": "Das Spiel konnte nicht gestartet werden.",
} as const;
